import axios from 'axios'
import { AzSearchUrlBuilder } from '@azinformatica/loki'

class AjusteApiClient {

    async salvar(dados) {
        return axios.post('api/ajustes', dados)
    }

    async buscarTodos(filtros, paginacao) {
        paginacao.descending = !paginacao.sortDesc[0]
        const url = AzSearchUrlBuilder.build('api/ajustes', filtros, paginacao)
        return axios.get(url)
    }

    async buscarPorId(id) {
        return axios.get(`api/ajustes/${id}`)
    }

    async buscarAjustePorPatrimonio(dados) {
        return axios.get(`api/patrimonios/${dados.idPatrimonio}/ajustes`)
    }

}

export default new AjusteApiClient()
